import { Field, ID, InputType, Int, ObjectType } from 'type-graphql'
import { DataArchive } from './data-archive.js'
import { ScalarObject } from '@things-factory/shell'

@InputType()
export class NewDataArchive {
  @Field({ nullable: true })
  type?: 'manual' | 'automatic' | string

  @Field(type => ScalarObject, { nullable: true })
  requestParams?: { [key: string]: any }

  @Field({ nullable: true })
  downloadUrl?: string

  @Field({ nullable: true })
  status?: string
}

@InputType()
export class DataArchivePatch {
  @Field(type => ID, { nullable: true })
  id?: string

  @Field({ nullable: true, description: 'Type of archive request (manual or automatic).' })
  type?: 'manual' | 'automatic' | string

  @Field(type => ScalarObject, {
    nullable: true,
    description: 'Parameters used for the archive request including query filters and export options.'
  })
  requestParams?: { [key: string]: any }

  @Field({ nullable: true, description: 'Presigned URL for downloading the archived data file.' })
  downloadUrl?: string

  @Field({ nullable: true, description: 'Current status of the archive request (pending, done, error).' })
  status?: string

  @Field({ nullable: true, description: 'Create/Update flag for batch operations.' })
  cuFlag: string
}

@ObjectType({ description: 'Represents a paginated list of data archives.' })
export class DataArchiveList {
  @Field(type => [DataArchive], { description: 'List of data archives.' })
  items: DataArchive[]

  @Field(type => Int, { description: 'Total number of data archives in the list.' })
  total: number
}
